import { useState, useCallback } from 'react';
import { SnackbarType } from './index';

interface SnackbarState {
  open: boolean;
  message: string;
  type: SnackbarType;
}

interface UseSnackbarReturn {
  snackbar: SnackbarState;
  showSnackbar: (message: string, type?: SnackbarType) => void;
  hideSnackbar: () => void;
}

export const useSnackbar = (): UseSnackbarReturn => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    type: 'success'
  });

  const showSnackbar = useCallback((message: string, type: SnackbarType = 'success') => {
    setSnackbar({
      open: true,
      message,
      type
    });
  }, []);

  const hideSnackbar = useCallback(() => {
    setSnackbar(prev => ({
      ...prev,
      open: false
    }));
  }, []);

  return {
    snackbar,
    showSnackbar,
    hideSnackbar
  };
};